import { Cookies } from 'react-cookie';

import { FullArchiveMapResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface GetDevicesArchiveOnMapParams {
  floor_slug: string;
  mode: string;
  date_value?: string;
  start_date?: string;
  end_date?: string;
}

export const getFullArchiveOnMap = async ({
  floor_slug,
  mode,
  date_value,
  start_date,
  end_date,
}: GetDevicesArchiveOnMapParams) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const response = await axiosInterceptor.get(`api/v1/traps/floor/${floor_slug}/archive/`, {
    headers: { Authorization: token },
    params: { mode, date_value, start_date, end_date },
  });

  return response.data as FullArchiveMapResponse;
};
